(function () {
  'use strict';
  const selection = window.LeavysProductSize;
  if (!selection) return;
  const originals = new WeakMap();
  function update() {
    const size = selection.current().size;
    document.querySelectorAll('[data-size-recommendations]').forEach((component) => {
      const cards = Array.from(component.querySelectorAll('.nf-card'));
      let count = 0;
      cards.forEach((card) => {
        if (!originals.has(card)) {
          const data = card.querySelector('[data-size-recommendation]');
          originals.set(card, { data: JSON.parse(data.textContent), price: card.querySelector('.nf-card__price').cloneNode(true), url: card.querySelector('.nf-card__title a').getAttribute('href'), variant: card.dataset.nfVariant, variantName: card.dataset.nfVariantName, amount: card.dataset.nfPrice });
        }
        const original = originals.get(card);
        const match = original.data.sizeIndex < 0 ? null : selection.matchSize(original.data.variants, size);
        card.hidden = Boolean((size && !match) || count >= Number(component.dataset.displayLimit));
        if (card.hidden) return;
        count += 1;
        card.querySelectorAll('.nf-card__title a,.nf-card__image > a').forEach((link) => { link.href = match ? match.url : original.url; });
        card.dataset.nfVariant = match ? match.id : original.variant;
        card.dataset.nfVariantName = match ? match.title : original.variantName;
        card.dataset.nfPrice = match ? match.price / 100 : original.amount;
        card.querySelectorAll('.nf-card__sizes a').forEach((link) => link.classList.toggle('is-selected', Boolean(size && link.textContent.trim() === size)));
        const price = card.querySelector('.nf-card__price');
        if (match) {
          const current = document.createElement('span');
          current.textContent = match.money;
          price.replaceChildren(current);
          if (match.compare > match.price) {
            current.className = 'nf-card__sale-price';
            const previous = document.createElement('s');
            previous.textContent = match.compareMoney;
            price.append(previous);
          }
        } else price.replaceWith(original.price.cloneNode(true));
      });
      component.hidden = !size && !count;
      const status = component.querySelector('[data-size-recommendation-status]');
      status.hidden = !size;
      status.textContent = size ? (count ? component.dataset.sizeMessage : component.dataset.emptyMessage).replace('__size__', size) : '';
      const browse = component.querySelector('[data-size-recommendation-browse]');
      browse.parentElement.hidden = !size || count > 0;
      if (size) {
        const url = new URL(component.dataset.browseUrl, location.origin);
        url.searchParams.set('filter.p.vendor', component.dataset.vendor);
        url.searchParams.set('filter.v.option.size', size);
        url.searchParams.set('filter.v.availability', '1');
        browse.href = url.pathname + url.search;
        browse.textContent = component.dataset.browseMessage.replace('__size__', size);
      }
      const title = component.querySelector('[data-recommended-product-count]');
      if (title) title.dataset.recommendedProductCount = count;
    });
  }
  document.addEventListener('leavys:size-change', update);
  document.querySelectorAll('[data-product-recommendations]').forEach((container) => new MutationObserver(update).observe(container, { childList: true }));
  update();
})();
